export function formatISODateStringToDottedDate(date: string) {
  if (!date) {
    return '';
  }

  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(date);
  const parsedDate = new Date(isDateOnly ? `${date}T00:00:00` : date);

  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  const day = String(parsedDate.getDate()).padStart(2, '0');
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');

  return `${day}.${month}.${parsedDate.getFullYear()}`;
}
